//import { Base64 } from 'js-base64';

//declare var Sizzle: any;
var Sizzle = require('sizzlejs');
var $ = Sizzle;

var loadedImages = {};

export const HTML_SPACE = '&nbsp;';
export const HREF_VOID = 'javascript: void(0);';

export type WebpCallbackType = (supported: boolean) => void;

export type AppHooksType = {
    onwebp: WebpCallbackType;
};

export enum ApplicationType {
    index,
    features
}

let appType: ApplicationType = null;

export function getAppType(): ApplicationType {
    if (appType === null) {
        appType = ApplicationType.index;
        const href = location.href.toLowerCase();
        if (href.indexOf('features.html') > -1) {
            appType = ApplicationType.features;
        }
    }
    return appType;
}

export function preloadImages(webpSupported: boolean, imagesToPreload: { [elementId: string]: string }) {
    for (var imgId in imagesToPreload) {
        if (imagesToPreload.hasOwnProperty(imgId)) {
            var imageFile = imagesToPreload[imgId];
            preloadImg(imageFile, webpSupported, imgId);
        }
    }
}

/* export function jsonToBase64(obj: Object): string {
    return Base64.encode(JSON.stringify(obj));
} */

export function getStatusColor(value: boolean): string {
    return value ? 'success' : 'danger';
}

export function isNullOrEmpty(value: any): boolean {
    return value === null || value === undefined || value === '';
}

export function getJSON(url, callback) {
    var xhr = new XMLHttpRequest();

    xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {
            try {
                var data = xhr.response;

                if (data === undefined || data === null &&
                    xhr.responseText !== undefined && xhr.responseText !== null) {
                    data = JSON.parse(xhr.responseText);
                }
                callback(data);
            } catch (err) {
                //console.log(err.message + " in " + xmlhttp.responseText);
                //return;
            }
        }
    };

    xhr.open('GET', url, true);
    xhr.responseType = 'json';
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.send();
}

export function getElementById<THtmlElement extends HTMLElement>(id: string): THtmlElement {
    var char = id.charAt(0);
    if (char !== '#') {
        id = '#' + id;
    }

    return getElementBySelector(id);
}

export function toggleShow(element: HTMLElement, show: boolean): void {
    if (element) {
        const remove = show ? 'd-none' : 'd-block';
        const add = show ? 'd-block' : 'd-none';

        element.classList.remove(remove);
        element.classList.add(add);
    }
}

export function updateCssClass(element: HTMLElement, cssClass: string, action: 'set' | 'remove'): void {
    if (element) {
        if (element.classList.contains(cssClass)) {
            if (action === 'remove') {
                element.classList.remove(cssClass);
            }
        } else {
            if (action === 'set') {
                element.classList.add(cssClass);
            }
        }
    }
}

export function getElementBySelector<THtmlElement extends HTMLElement>(selector: string, context?: any): THtmlElement {
    var res = $(selector, context);
    return res.length === 1 ? res[0] : null;
}

export function getClosest(elem, selector) {
    // Element.matches() polyfill
    if (!Element.prototype.matches) {
        Element.prototype.matches =
            (Element.prototype as any).matchesSelector ||
            (Element.prototype as any).mozMatchesSelector ||
            (Element.prototype as any).msMatchesSelector ||
            (Element.prototype as any).oMatchesSelector ||
            (Element.prototype as any).webkitMatchesSelector ||
            function (s) {
                var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                    i = matches.length;
                while (--i >= 0 && matches.item(i) !== this) {
                }
                return i > -1;
            };
    }

    // Get the closest matching element
    for (; elem && elem !== document; elem = elem.parentNode) {
        if (elem.matches(selector)) return elem;
    }

    return null;
}

function autoCompleteOff(input) {
    if (input.type.toLowerCase() === 'hidden') {
        return;
    }

    var readonly = input.getAttribute('readonly');
    var hasReadonly = readonly !== undefined && readonly !== null;
    var ac = input.getAttribute('autocomplete');
    var hasAutoCompleted = ac && ac.toLowerCase() === 'off';
    if (hasAutoCompleted && hasReadonly) {
        input.removeAttribute('readonly');
        input.removeAttribute('onfocus');
    }
}

window['autoCompleteOff'] = autoCompleteOff;

export function delayedFocus(ctrlOrId: string | HTMLElement, timeout: number = 200) {
    var ctrl = ctrlOrId;
    if (typeof ctrlOrId === 'string') {
        ctrl = getElementById(ctrlOrId);
    }

    if (ctrl) {
        setTimeout(function delayedFocus(c) {
            c.focus();
        }, timeout, ctrl);
    }
}

export function enterToSubmitForm(inputIds, form) {
    for (var i = 0; i < inputIds.length; i++) {
        var inputId = inputIds[i];
        var input = getElementById(inputId);
        if (input) {
            input.addEventListener('keypress', function (e) {
                if (e.which === 13) {
                    form.submit();
                }
            });
        }
    }
}

export function attachEvent(elementIds, eventName, eventCallback) {
    const isArr = typeof elementIds === 'object' && (elementIds.length !== undefined);

    if (!isArr) {
        elementIds = [elementIds];
    }

    for (var i = 0; i < elementIds.length; i++) {
        var elementId = elementIds[i];
        var element = getElementById(elementId);
        if (element) {
            element.addEventListener(eventName, eventCallback);
        }
    }
}

export function attachEventToElements(elements: HTMLElement[], eventName: string, eventCallback) {
    for (var i = 0; i < elements.length; i++) {
        var element = elements[i];
        if (element) {
            element.addEventListener(eventName, eventCallback);
        }
    }
}

export function formSubmit(form: string | HTMLFormElement): void {
    if (typeof form === 'string') {
        form = getElementById(form) as HTMLFormElement;
    }

    if (form) {
        const submitEvent = new Event('submit', {
            bubbles: true,
            cancelable: true
        });

        const cancelled = !form.dispatchEvent(submitEvent);
        if (!cancelled) {
            form.submit();
        }
    }
}

export function removeElements(elements: HTMLElement[]) {
    forEach(elements, element => {
        if (element) {
            element.parentElement.removeChild(element);
        }
    });
}

export function forEach<T>(items: T[], action: (item: T) => void) {
    const isArr = typeof items === 'object' && (items.length !== undefined);
    if (isArr) {
        for (let i = 0; i < items.length; i++) {
            action(items[i]);
        }
    }
}

export function insertAfter(newNode, referenceNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}

export function preloadImg(src, webp, targetImgId) {
    var key = src;
    var parts = src.split('.');
    var file = parts[0];
    var ext = parts[1];

    src = 'images/' + (webp ? 'webp/' : '') + file + (webp ? '.webp' : ('.' + ext));
    var img = new Image();

    img.onload = function () {
        var targetImg = document.getElementById(targetImgId) as HTMLImageElement;
        if (targetImg) {
            targetImg.src = (this as any).src;
        } else {
            //console.log('could not found img tag with id "' + targetImgId + '"');
        }
    };

    img.src = src;
    loadedImages[key] = img;
}